import React from 'react'
import { useLocation, Location } from 'react-router-dom'
import { usePrevious } from 'react-use'

/**
 * listen to location change
 *
 * action handler to be called when location change
 */
export function useLocationChange(
  action: (location: Location, prev: Location | undefined) => void
) {
  const location = useLocation()
  const prevLocation = usePrevious(location)
  React.useEffect(() => {
    action(location, prevLocation)
  }, [action, location, prevLocation])
}
